import PropTypes from "prop-types";
import {Dropdown} from "primereact/dropdown";



export function CustomerSelect(props) {
    const handleChange = (event) => {
        const myValue = props.customerList.find(x => x.id === event.target.value)

            props.setCustomer({
                id: myValue.id,
                name: myValue.name,
                initialBalance: myValue.initialBalance,
                customerGroup: myValue.customerGroup
            });
    };
    return (
        <div className="flex flex-fill justify-content-start flex-wrap flex-shrink-0 md:flex-nowrap">
            <Dropdown value={props.customer.id} onChange={handleChange} options={props.customerList}
                      optionLabel="name" optionValue="id" disabled={props.disable}
                      placeholder="Customer " tooltip="Select Customer" variant="filled"
                       autoFocus={true} focusOnHover={true} highlightOnSelect={true} filter className="flex-1 w-10 h-2rem align-items-center justify-content-center"
                      tabIndex={0}/>

        </div>
    )

}

CustomerSelect.propTypes = {
    customer: PropTypes.object.isRequired,
    setCustomer: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,
    customerList: PropTypes.array.isRequired,
}
